







































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { cloneDeep } from 'lodash';
import * as service from '@/services/materials';
import * as serviceMeasurementUnit from '@/services/measurement-unit';
import IMaterial, { IClassification } from '@/interfaces/material';
import { IMeasurementUnit } from '@/interfaces/measurement-unit';
import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import { filterByText } from '@/helpers/filterByText';
import { errorHandling } from '@/helpers/errorHandling';
import {
  MESSAGE_MATERIALS_ERROR,
  MESSAGE_MATERIALS_DELETE_ERROR,
} from '@/settings/consts/messages';
import {
  ERROR_CODE_MATERIALS_DUPLICATE,
  ERROR_CODE_MATERIALS_DELETE,
} from '@/settings/consts/api-error';

@Component({
  components: { PermissionAuth, ListMessages },
})
export default class Materials extends BaseComponent {
  public formOpen: boolean = false;
  public error: boolean = false;
  public loading: boolean = false;

  public filter: any = {
    term: '',
  };

  public form: any = {
    valid: false,
    rules: {
      code: [(v) => !!v || 'Digite um código'],
      name: [(v) => !!v || 'Digite um nome'],
      unit: [(v) => !!v || 'Selecione uma unidade de medida'],
    },
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  public headers: any = [
    { text: 'Código', value: 'codigo' },
    { text: 'Nome', value: 'descricao' },
    { text: 'Unidade de medida', value: 'unidadeMedida.sigla' },
    { text: 'Ações', value: 'actions', align: 'right', sortable: false },
  ];

  public measurementUnits: IMeasurementUnit[] = [];
  public classifications: IClassification[] = [];
  public defaultClassification: IClassification = {
    id: null,
    descricao: 'Nenhum',
  };

  public data: IMaterial[] = [];
  public item: IMaterial = {
    id: 0,
    codigo: '',
    descricao: '',
    classificacao: this.defaultClassification,
    termogenico: false,
    correcaoEnteral: false
  };

  public beforeMount(): void {
    this.load();
    this.getMeasurementUnits();
    this.getClassifications();
  }

  public onEditItem(item: IMaterial): void {
    this.formOpen = true;
    this.item = cloneDeep(item);
    if (!this.item.classificacao) {
      this.item.classificacao = this.defaultClassification;
    }
  }

  public onDeleteItem(item: IMaterial): void {
    const deleteItem = () => {
      const onError = (error) => {
        this.loader.stop();

        const errorMessages = {
          default: MESSAGE_MATERIALS_DELETE_ERROR,
          [ERROR_CODE_MATERIALS_DELETE]:
            !!error && !!error.data
              ? error.data.message
              : MESSAGE_MATERIALS_DELETE_ERROR,
        };

        const message = errorHandling(error, errorMessages);
        this.toast.show(message, 'error');
      };

      this.loader.start('Deletando registro...');
      service.deleteMaterial(item.id).subscribe((data) => {
        this.loader.stop();
        this.load();
      }, onError);
    };

    this.dialog.show(
      'error',
      'Excluir Ativo',
      'Tem certeza que deseja excluir este ativo?',
      'Cancelar',
      '',
      'Excluir',
      deleteItem,
    );
  }

  public customFilter(items, search, filter): any[] {
    const searchLower = search.toString().toLowerCase();
    return items.filter((row) => {
      return (
        filterByText(row, ['descricao', 'codigo'], searchLower) ||
        filterByText(row.unidadeMedida, ['sigla'], searchLower)
      );
    });
  }

  public saveItem(): void {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }

    this.loader.start('Salvando registro...');

    const onError = (error) => {
      this.loader.stop();

      const errorMessages = {
        default: MESSAGE_MATERIALS_ERROR,
        [ERROR_CODE_MATERIALS_DUPLICATE]:
          !!error && !!error.data
            ? error.data.message
            : MESSAGE_MATERIALS_ERROR,
      };

      const message = errorHandling(error, errorMessages);
      this.toast.show(message, 'error');
    };

    const payload = cloneDeep(this.item);

    if (!this.item.id) {
      service.saveMaterial(payload).subscribe((data) => {
        this.loader.stop();
        this.formOpen = false;
        this.load();
      }, onError);
    } else {
      service.updateMaterial(payload).subscribe((data) => {
        this.loader.stop();
        this.formOpen = false;
        this.load();
      }, onError);
    }
  }

  public newItem(): void {
    this.formOpen = true;
    this.item = {
      id: 0,
      codigo: '',
      descricao: '',
      classificacao: this.defaultClassification,
      termogenico: false,
      correcaoEnteral: false
    };
    this.$refs.form.resetValidation();
  }

  public closeForm(): void {
    const closeAction = () => {
      this.formOpen = false;
    };

    this.dialog.show(
      'error',
      'Sair sem salvar',
      'Deseja sair sem salvar as alterações?',
      'Cancelar',
      '',
      'Sair',
      closeAction,
    );
  }

  private load(): void {
    this.data = [];
    this.loading = true;
    service.getMaterials().subscribe(
      (data) => {
        this.data = data;
        this.loading = false;
      },
      () => {
        this.loading = false;
        this.error = true;
      },
    );
  }

  private getMeasurementUnits(): void {
    serviceMeasurementUnit.listAll().subscribe((data) => {
      this.measurementUnits = data;
    });
  }

  private getClassifications(): void {
    service.getClassifications().subscribe((data) => {
      const classifications = data;
      classifications.unshift(this.defaultClassification);
      this.classifications = classifications;
    });
  }
}
